import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import * as mediaQuery from "components/MediaQuery";
import { calcRem } from "styles/theme";
const leftRightPadding = "14px";

export const PopupWrapper = styled.ul`
  position: absolute;
  right: 0;
  z-index: 995;
  background-color: ${COLORS.WHITE};
  border: 1px solid #abb5c5;
  border-radius: 5px;
  padding: 7px 0;
  top: 100%;

  ${mediaQuery.isDefault} {
    right: 0;
  }

  ${mediaQuery.isMobile} {
    width: auto;
    max-width: 100%;
    margin-top: 10px;
  }
`;

export const Popup = styled.li`
  font-size: ${calcRem(14)};
  font-weight: 400;
  padding: 8px ${leftRightPadding};
  padding-right: 8px;
  ${FLEX.FlexStartCenter};
  gap: 8px;
  cursor: pointer;
  white-space: nowrap;
`;

export const PopupMenu = styled(Popup)<{
  disabled: boolean;
  isCurrent?: boolean;
  isFocus?: boolean;
}>`
  position: relative;
  line-height: 16px;
  transition: all ease-out 0.1s;
  &:hover {
    background: ${(props) => !props.disabled && "rgba(100, 100, 100, 0.1)"};
  }
  ${(props) => props.isFocus && "background: rgba(100, 100, 100, 0.1);"}
  ${(props) => props.isCurrent && "background: rgba(100, 100, 100, 0.1);"}
  color: ${(props) => props.disabled && "#ddd"};
`;

export const AccountId = styled(Popup)`
  color: ${COLORS.BORDER};
  font-size: ${calcRem(12)};
  ${FLEX.FlexBetweenCenter};
  gap: 5px;
  padding: 4px ${leftRightPadding} 8px;
  cursor: unset;

  span:nth-child(2) {
    font-weight: 500;
    background-color: ${COLORS.LIGHTGRAY}40;
    padding: 4px;
    ${FLEX.FlexStartCenter};

    button {
      padding: 0;
      ${FLEX.FlexCenterCenter};
    }
  }
`;

export const Line = styled.div`
  border-bottom: 1px solid ${COLORS.BUTTONS1};
  margin: 6px ${leftRightPadding};
`;

export const SwitchAccount = {
  Popup: styled.div`
    position: absolute;
    top: 0;
    right: 100%;
    width: 280px;
    background-color: ${COLORS.WHITE};
    border: 1px solid #abb5c5;
    border-radius: 5px;
    cursor: default;
    z-index: 999;
    .spinner-wrapper {
      padding-bottom: 40px;
    }
    .no-data {
      padding: 40px 0;
    }
    .search-input-wrapper {
      border: 0;
      margin: 15px 15px 0;
      width: calc(100% - 30px);
      background-color: ${COLORS.BLACK}10;
    }
    ${mediaQuery.isMobile} {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      right: auto !important;
      width: 100vw !important;
      max-width: 100vw !important;
      height: 100dvh !important;
      border-radius: 0;
      border: 0;
      overflow-y: auto;
      overflow-x: hidden;
      -webkit-overflow-scrolling: touch;
    }
  `,
  Item: styled.div<{ isCurrent: boolean; disabled: boolean }>`
    ${FLEX.FlexBetweenCenter};
    padding: 4px ${leftRightPadding};
    ${mediaQuery.isMobile} {
      padding: 8px 14px;
    }
    cursor: pointer;
    color: ${COLORS.BLACK}90;
    ${(props) =>
      props.isCurrent
        ? `
    cursor: default;
    background: ${COLORS.BUTTONS2}15;
    font-weight: 500;
    color: ${COLORS.BLACK};
  `
        : props.disabled
        ? `
    cursor: not-allowed;
    filter: grayscale(100%);
    color: ${COLORS.BLACK}30;
  `
        : `
    &:hover {
      background: ${COLORS.LIGHTGRAY}15;
      color: ${COLORS.BLACK};
    }
  `}
    .copy-button {
      padding: 0;
      ${FLEX.FlexCenterCenter};
      cursor: pointer;
      opacity: 0;
    }
    &:hover {
      .copy-button {
        opacity: 0.5;
      }
    }
    ${mediaQuery.isMobile} {
      width: 100%;
    }
  `,
  Label: styled.div`
    ${FLEX.FlexStartStart};
    gap: 5px;
    font-size: ${calcRem(14)};
    > span {
      white-space: normal;
      word-break: break-all;
      padding: 3px 0;
    }
    ${mediaQuery.isMobile} {
      font-size: ${calcRem(16)};
    }
  `,
  Toggle: styled.div`
    ${FLEX.FlexCenterCenter};
    font-size: ${calcRem(12)};
    color: ${COLORS.COMPANY};
    padding: 10px ${leftRightPadding};
    cursor: pointer;
    text-decoration: underline;
    border-top: 1px solid ${COLORS.LIGHTGRAY}30;
    ${mediaQuery.isMobile} {
      font-size: ${calcRem(16)};
      padding-bottom: 0;
    }
  `,
  List: styled.div`
    max-height: 400px;
    padding-bottom: 7px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLORS.BLACK}20;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLORS.WHITE};
    }
    ${mediaQuery.isMobile} {
      max-height: calc(100dvh - 100px);
    }
  `,
  Level: styled.div`
    font-size: ${calcRem(11)};
    padding: 12px ${leftRightPadding} 2px;
    margin-top: 5px;
    border-top: 1px solid ${COLORS.LIGHTGRAY}30;
    text-transform: uppercase;
    color: ${COLORS.BLACK}90;
    font-weight: 500;
    &:first-child {
      border-top: 0;
    }
  `,
};
